var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(0.583344 7.58334)",
    d: "M26.8333 4.66667L0 4.66667L0 0L26.8333 0L26.8333 4.66667Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(1.75 12.25)",
    d: "M24.5 14L0 14L0 0L24.5 0L24.5 14Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(9.91666 7.58334)",
    d: "M0 0L0 18.6667"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(18.0833 7.58334)",
    d: "M0 18.6667L0 0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(14.0002 0.000114441)",
    d: "M6.59983 4.97933C5.46 6.11917 0 7.45383 0 7.45383C0 7.45383 1.33467 1.99267 2.4745 0.854C3.61317 -0.284667 5.46 -0.284667 6.59983 0.854C7.7385 1.99267 7.7385 3.8395 6.59983 4.97933L6.59983 4.97933Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(6.5455 0.000114441)",
    d: "M0.853948 4.97933C1.99313 6.11917 7.45 7.45383 7.45 7.45383C7.45 7.45383 6.11493 1.99267 4.97692 0.854C3.8389 -0.284667 1.99313 -0.284667 0.853948 0.854C-0.284066 1.99267 -0.285232 3.8395 0.853948 4.97933L0.853948 4.97933Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon_gift.2310914e4bf8300494d1be9d363bc148.svg";
export { ForwardRef as ReactComponent };